import React, { useState } from 'react';
import { Box, Container, IconButton, Toolbar } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Header from './Header';
import Sidebar from './Sidebar';

import { useAuth } from '../../contexts/AuthContext';
import { useLocation } from 'react-router-dom';

const drawerWidth = 240;

const Layout = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { currentUser } = useAuth();
  const location = useLocation();
  
  // Don't show navigation for login page
  const isAuthPage = location.pathname === '/login';

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      {/* Only show sidebar if user is logged in and not on auth pages */}
      {currentUser && !isAuthPage && (
        <Sidebar mobileOpen={mobileOpen} handleDrawerToggle={handleDrawerToggle} />
      )}
      
      <Box sx={{ 
        flexGrow: 1, 
        width: currentUser && !isAuthPage ? { sm: `calc(100% - ${drawerWidth}px)` } : '100%',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        bgcolor: '#f5f5f5'
      }}>
        {/* Only show header if user is logged in or on authenticated pages */}
        {currentUser && !isAuthPage && (
          <Header>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: { xs: 0, md: 2 }, display: { sm: 'none' } }}
            >
              <MenuIcon />
            </IconButton>
          </Header>
        )}
        
        <Box component="main" sx={{ flexGrow: 1 }}>
          <Container maxWidth="xl" sx={{ mt: 0, px: 1 }}>
            {children}
          </Container>
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
